import { format } from 'date-fns'

import { SelectedDepartures } from '@/states/selection.interface'

import { getDatepickerLocale } from './dateAndTimeHelpers'

export const formatChevronDate = (date: string): string => {
  const newDate = new Date(date)
  return format(newDate, 'dd MMMM yyyy', { locale: getDatepickerLocale() })
}

export const hasOverlapping = (selectedDepartures: SelectedDepartures | undefined): boolean =>
  selectedDepartures?.departureOut?.arrivalDateTime &&
  selectedDepartures.departureHome?.checkinDateTime &&
  selectedDepartures?.departureOut?.arrivalDateTime >= selectedDepartures.departureHome?.checkinDateTime
    ? true
    : false

export const hasOutButNotHome = (selectedDepartures: SelectedDepartures | undefined): boolean =>
  hasHHMM(selectedDepartures?.departureOut?.departureDateTimeForBasket) &&
  !hasHHMM(selectedDepartures?.departureHome?.departureDateTimeForBasket)

export const hasHomeButNotOut = (selectedDepartures: SelectedDepartures | undefined): boolean =>
  !hasHHMM(selectedDepartures?.departureOut?.departureDateTimeForBasket) &&
  hasHHMM(selectedDepartures?.departureHome?.departureDateTimeForBasket)

export const hasNeitherOutOrHome = (selectedDepartures: SelectedDepartures | undefined): boolean =>
  !hasHHMM(selectedDepartures?.departureOut?.departureDateTimeForBasket) &&
  !hasHHMM(selectedDepartures?.departureHome?.departureDateTimeForBasket)

export const hasNotOut = (selectedDepartures: SelectedDepartures | undefined): boolean =>
  !hasHHMM(selectedDepartures?.departureOut?.departureDateTimeForBasket)

const hasHHMM = (departure: string | null | undefined): boolean =>
  departure && /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d/.test(departure) ? true : false
